<template>
  <article class="soporte-article px-2">
    <!-- <div class="breadcrumb">
      <template v-for="(bc, $index) in breadcrumbLinks">
        <a
          class="color-primary"
          @click="$router.push({ name: bc.path })"
          :key="`breadcrumb-${bc.name}-${$index}`"
          >{{ bc.name }}</a
        >
        >
      </template>
      <span>{{ breadcrumbEnd.name }}</span>
    </div> -->
    <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
      <ul>
        <li
          v-for="(bci, $index) in bc"
          :key="`breadcrumb-${bci.name}-${$index}`"
        >
          <a @click="toLink(bci)">{{ bci.name }}</a>
        </li>
        <li class="is-active">
          <a href="#" aria-current="page">{{ article.title }}</a>
        </li>
      </ul>
    </nav>
    <!-- <slot v-bind="{list}" name="article-list">

    </slot> -->
    <h3>{{ article.title }}</h3>
    <section
      v-html="article.content"
      class="soporte-article__content"
    ></section>
  </article>
</template>

<script>
export default {
  name: "SoporteArticle",
  props: {
    title: {
      type: String,
      default: "How do I get started in ContaFácil?"
    },
    path: {
      type: Array,
      default: function() {
        return [
          { name: "Home", path: "soporte-list" },
          { name: "Dashboard", path: "soporte-dashboard" },
          { name: "Dashboard", path: "soporte-dashboard" },
          { name: "How do I get started in ContaFácil", path: "" }
        ];
      }
    },
    content: {
      type: String,
      default: `
        <p>ContaFácil es una herramienta eficiente y fácil de usar orientada a simplificar la forma de manejar tu negocio. Hacemos más eficiente el proceso de venta orientado a mejorar la productividad del negocio, reduciendo costos y tiempo.</p>
        <ul>
          <li>Ingresar a tu cuenta</li>
          <li>Echa un vistazo a nuestro Webinar</li>
          <li>Aceptamos tarjetas</li>
        </ul>
        <h4></h4>
      `
    }
  },
  data() {
    return {
      bc: null
    };
  },
  async created() {
    this.$modal.show("loader-root");
    await this.$store.dispatch("getSupportContent", this.$route.params.slug);
    this.bc = this.$route.params.path;
    this.$modal.hide("loader-root");
  },
  computed: {
    breadcrumbLinks() {
      return this.path.slice(0, this.path.length - 1);
    },
    breadcrumbEnd() {
      return this.path[this.path.length - 1];
    },
    article() {
      if (!this.$store.getters.actualContentSupport) return {};
      return this.$store.getters.actualContentSupport;
    }
  },
  methods: {
    toLink(val) {
      console.log(val);
      if (val.id) {
        if (!val.hash) {
          this.$router.push({ name: val.path, params: { id: val.id } });
        } else {
          this.$router.push({
            name: val.path,
            params: { id: val.id },
            hash: val.hash
          });
        }
      } else {
        this.$router.push({ name: val.path });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/general.scss";
@import "../../assets/styles/colors.scss";
.soporte-article {
  // padding: 0 3rem;
  h3 {
    text-align: start;
    font-weight: bold;
    letter-spacing: 0.05em;
  }
  &__content {
    text-align: start;
    margin-bottom: 6rem;
    h4 {
      font-weight: bold;
      font-size: 2.8rem;
    }
    & /deep/ p,
    & /deep/ div {
      margin: 1rem auto;
    }
    & /deep/ ul {
      list-style: disc;
      margin-left: 3rem;
      li {
        color: $primary;
        padding: 1rem 0;
        margin: 0;
        a {
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  @include tablet() {
    h3 {
      font-size: 1.5rem;
      margin: 1.5em 0;
    }
    &__content {
      text-align: start;
      margin-bottom: 6rem;
      h4 {
        font-weight: bold;
        font-size: 2.8rem;
      }
      & /deep/ p,
      & /deep/ div {
        font-size: 1.2rem;
      }
      & /deep/ ul {
        font-size: 1.2rem;
      }
    }
  }
  @include laptop() {
    h3 {
      font-size: 2rem;
    }
    &__content {
      text-align: start;
      margin-bottom: 6rem;
      width: 100%;
      h4 {
        font-weight: bold;
        font-size: 2.8rem;
      }
      & /deep/ p,
      & /deep/ div {
        font-size: 1.5rem;
      }
      & /deep/ ul {
        font-size: 1.5rem;
      }
    }
  }
  @include desktop-medium() {
    h3 {
      font-size: 2rem;
    }
    &__content {
      text-align: start;
      margin-bottom: 6rem;
      width: 75%;
      h4 {
        font-weight: bold;
        font-size: 2.8rem;
      }
      & /deep/ p,
      & /deep/ div {
        font-size: 1.5rem;
      }
      & /deep/ ul {
        font-size: 1.5rem;
      }
    }
  }
}
.section-more-categories {
  background-color: #eafffe;
  padding: 5rem 1rem;
  padding-top: 2rem;
  margin: 0px;
  .more-categories-content {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0px;
  }
  h3 {
    text-align: start;
    font-weight: bold;
    font-size: 1rem;
    letter-spacing: 0.1em;
    margin: 1em 0;
  }
  .categories {
    // display: flex;
    // flex-flow: row nowrap;
    // justify-content: space-between;
    // align-items: flex-start;

    ul {
      text-align: start;
      font-weight: bold;
      font-size: 0.8rem;
      margin: 0;
      padding-top: 0;
      padding-bottom: 0;
      // margin-right: 1rem;
    }
  }
  @include tablet() {
    h3 {
      font-size: 2rem;
    }
    .categories {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: flex-start;
      ul {
        font-size: 1.2rem;
      }
    }
  }
  @include laptop() {
    padding: 2rem 3rem;
    margin-bottom: 3rem;
    h3 {
      margin: 1rem 0 2rem;
    }
    .categories {
      width: 100%;
      ul {
        list-style: disc;
        margin-left: 2rem;
        li {
          margin-bottom: 1rem;
        }
      }
    }
  }
}
// .breadcrumb {
//   margin: 0;
//   margin-bottom: 3rem;
//   text-align: start;
//   font-size: 1.4rem;
//   letter-spacing: 0.025em;
//   a {
//     cursor: pointer;
//   }
// }
</style>
